module.exports = __webpack_public_path__ + "img/Email-template_background.e0f0394a.jpg";